// Vite browser bundles have no `process` global, so never touch it bare.
function getProcessEnv(): Record<string, string | undefined> {
  return typeof process !== "undefined" && process.env ? process.env : {};
}

function readEnv(name: string): string | undefined {
  const env = getProcessEnv();
  return env[name] ?? env[`NEXT_PUBLIC_${name}`] ?? env[`EXPO_PUBLIC_${name}`];
}

export function getSentryDsn(): string | undefined {
  return readEnv("SENTRY_DSN");
}

export function getEnvironment(): string {
  return readEnv("SENTRY_ENVIRONMENT") ?? "development";
}

export function getRelease(): string | undefined {
  return readEnv("SENTRY_RELEASE") ?? getProcessEnv().VERCEL_GIT_COMMIT_SHA;
}

export function isSentryEnabled(): boolean {
  const enabledFlag = readEnv("SENTRY_ENABLED");
  return (
    enabledFlag === "true" &&
    getEnvironment() === "production" &&
    Boolean(getSentryDsn())
  );
}

export function getTracesSampleRate(app?: string): number {
  const override = readEnv("SENTRY_TRACES_SAMPLE_RATE");
  if (override) {
    const parsed = Number.parseFloat(override);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  if (app === "api" || app === "mcp-server") {
    return 0.05;
  }

  return 0.02;
}
